import { Flex, Text } from '@baont0209/pibridge_uikit_v20';
import { useWeb3React } from '@web3-react/core';
import ConnectWalletButton, { CsButton } from 'components/ConnectWalletButton';
// eslint-disable-next-line import/named
import { AutoRenewIcon, Button } from 'components/Pancake-uikit';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// import Countdown, { zeroPad } from 'react-countdown'
import { useTranslation } from 'contexts/Localization';
import Countdown from 'react-countdown-now';
import { zeroPad } from 'react-countdown';
import { CheckUserMint, CheckUserMintedMap, CheckWhiteList } from '../hooks/fetchData';
import { useMintPiNft } from '../hooks/useMintPiNft';
import { FrameEventTime, ImgWhiteList, TextCenter, TextHead, TextNumberDay, TextTitle, WrapBtn } from '../styles';
import { FetDataPiBridge } from '../hooks/fetDataPiBridgeNft';

const CardTime = () => {
    const account = useWeb3React();
    const [isStartTime, setIsStartTime] = useState(false);
    const {dataUser} = CheckUserMint();  
    const {handleMint, pendingTx, requestedMint, isAccoutLogin} = useMintPiNft(account.account);
    const { isWhiteList } = CheckWhiteList(account.account, requestedMint);
    const { isUserMintedMap } = CheckUserMintedMap(account.account);
    const { t } = useTranslation()

    // axios getData PiBridge Nft
    const { dataInfoNtf } = FetDataPiBridge(account?.account);

    // countDown startTime contract nft
    const countDownTime = dataUser.startTimeMint*1000 - new Date().getTime();

      const renderCountdownV2 = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            setIsStartTime(true);
            return ( 
                <></>
            )
        }
        return (
            <WrapListTime width="100%" justifyContent="space-between">
                <Card flexDirection="column" justifyContent="center">
                    <StyCountDown>
                        <TextTime color="#494949" fontSize="26px">{zeroPad(days)}</TextTime>
                    </StyCountDown>
                    <TextTimeLetter color='#000000' mt="0.5rem" textAlign="center">{t("DAYS")}</TextTimeLetter>
                </Card>
                <Card flexDirection="column" justifyContent="center">
                    <StyCountDown>
                        <TextTime color="#494949" fontSize="26px">{zeroPad(hours)}</TextTime>
                    </StyCountDown>
                    <TextTimeLetter color='#000000' mt="0.5rem" textAlign="center">{t("HOURS")}</TextTimeLetter>
                </Card>
                <Card flexDirection="column" justifyContent="center">
                    <StyCountDown>
                        <TextTime color="#494949" fontSize="26px">{zeroPad(minutes)}</TextTime>
                    </StyCountDown>
                    <TextTimeLetter color='#000000'  mt="0.5rem" textAlign="center">{t("MINUTES")}</TextTimeLetter>
                </Card>
                <Card flexDirection="column" justifyContent="center">
                    <StyCountDown>
                        <TextTime color="#494949" fontSize="26px">{zeroPad(seconds)}</TextTime>
                    </StyCountDown>
                    <TextTimeLetter color='#000000' mt="0.5rem" textAlign="center">{t("SECONDS")}</TextTimeLetter>
                </Card>
            </WrapListTime>
        )
    }

    return (
        <FrameEventTime>     
            <Flex justifyContent='center'>
                <CsTextTitle>PIBRIDGE TESSERACT NFTs</CsTextTitle>
            </Flex>
            <Flex justifyContent='center' alignItems="baseline">
                <TextCenter textTransform='uppercase' mr='20px' fontSize='13px'>minted</TextCenter>
                <TextNumberDay>{dataUser.whitelistMintedCount}</TextNumberDay>    
            </Flex>
            <Flex justifyContent='center'>
                <ImgWhiteList src='./images/ImgPi/pi-revolution.png'/>
            </Flex>
            <Flex>
                {!isStartTime && <TextHead>event time left</TextHead>}
            </Flex>

            {/* Card Time */}
            <WrapTime>
                <Countdown zeroPadTime={2} date={dataUser.startTimeMint*1000}  renderer={renderCountdownV2}/>
            </WrapTime>

            <WrapBtn>
               {account.account === undefined  ?
               <ConnectWalletButton scale="sm" />
               :
               countDownTime > 0 ?
                <CSButtonCp disabled>mint nft</CSButtonCp>
                :
                <CSButtonCp endIcon={ requestedMint ? <AutoRenewIcon  spin color="#494949" /> : null} disabled={isUserMintedMap || !isStartTime || !isWhiteList || pendingTx || requestedMint || !isAccoutLogin} onClick={handleMint}>mint nft</CSButtonCp>
               }
      
                
            </WrapBtn>

            {account.account === undefined &&
            <Flex>
                <TextError>Connect your BEP-20 wallet</TextError>
            </Flex>
            }

            { isWhiteList && account.account !== undefined &&
              <>
                {
                        isUserMintedMap ?
                      <Flex flexDirection='column' justifyContent='center'>
                          {dataInfoNtf.token_id ?
                              <TextError>{`PiBridge Tesseract NFT ID: ${dataInfoNtf.token_id}`}</TextError>
                              :
                              <TextError>NFT</TextError>
                          }
                          <TextError>has been minted</TextError>
                      </Flex>
                      :
                      <>
                        { !requestedMint ?
                            <Flex>
                                <TextSuccess>You are whitelisted</TextSuccess>
                            </Flex>
                            :
                            ""
                        }
                      </>

                }
              </>
            }

            {!isWhiteList && !isUserMintedMap && account.account !== undefined &&
               <>
                    <Flex>
                        <TextError>You are not whitelisted</TextError>
                    </Flex>
               </>
            }

     </FrameEventTime>
    );
};

export default CardTime;

const CsTextTitle = styled(TextTitle)`
  text-transform: none;
  @media screen and (min-width: 2000px) {
    font-size: 22px;
  }
`

const WrapTime = styled(Flex)`
    width: 100%;    
    justify-content: center;
    gap: 12px;
`

const Card = styled(Flex)`
    border: 1px solid ${({theme}) => theme.colors.textColor};
    flex-direction: column;
    width: 75px;
    height: 90px;
    align-items: center;
    justify-content: center;
  @media screen and (max-width: 600px) {
     width: 70px;
    height: 80px;
  }
  @media screen and (max-width: 400px) {
     width: 60px;
    height: 75px;
  }
`

const TextTime = styled(Text)`
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    color:#494949;
`

const TextError = styled(Text)`
    color: #FD6969 !important;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
`

const TextSuccess = styled(Text)`
    color: #299f11 !important;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 150%;
`

const CSButtonCp = styled(Button)`
   background-color: transparent;
  border-bottom: none;
  box-shadow: none;
  border: 1px solid ${({theme}) => theme.colors.textColor};
  border-radius: 0px;
  color:#494949;
  width: 200px;
  height: 60px;
  text-transform: uppercase;
  font-weight: 300;
  padding: 0px;
  @media screen and (max-width: 1024px) {
    width: 150px;
    height: 50px;
    font-size: 12px;
  }
  &.pancake-button--disabled {
    border: 1px solid #999999;
    background-color: rgb(233, 234, 235);
    border-color: rgb(233, 234, 235);
    box-shadow: none;
    color: rgb(189, 194, 196);
    cursor: not-allowed;
  }
`

const StyCountDown = styled(Flex)`
    width: 80px;
    height: 30.5px;
    align-items:center;
    justify-content:center;
    background-repeat:no-repeat;
    background-size: auto;

`

const WrapListTime = styled(Flex)`
    justify-content: center;
    gap: 8px;
    @media screen and (max-width: 600px) {
        gap: 12px;
    }
`

const TextTimeLetter = styled(Text)`
    font-weight: 400;
    font-size: 13px;
`